import type { VideoAssetStatus } from './videoAsset.types';

type VideoAssetWithStatus = Readonly<{ status?: VideoAssetStatus | null }> | null | undefined;

/** Whether a status has a file behind it. photo_service sends `url: ''` for every other status. */
export const isReadyStatus = (status: VideoAssetStatus | null | undefined): boolean => status === 'READY';

/**
 * Whether a video has a file to play. Guests see only these, and admin plays, picks and runs in the slideshow only these.
 * A missing status is not ready: every selection that feeds this asks for `status`.
 */
export const isReadyVideo = (videoAsset: VideoAssetWithStatus): boolean => isReadyStatus(videoAsset?.status);
